(function() {
    document.addEventListener('DOMContentLoaded', (event) => {
        document.addEventListener('click', (evt) => {
            if ( evt.target.classList.contains('grid-product__add-to-cart') || 
                evt.target.parentElement.classList.contains('grid-product__add-to-cart')
            ) {
                evt.preventDefault()
                evt.stopPropagation()
                let elem
                if ( evt.target.tagName.toLowerCase() === 'div' ) elem = evt.target
                else elem = evt.target.parentElement

                const spanText = elem.children[0].textContent
                if ( elem.dataset.available === 'true' )  {
                    const varId = elem.dataset.variantId
                    elem.children[0].textContent = 'AÑADIENDO...'
                    
                    addToCart( varId, 1, ( cartUpdated ) => {
                        console.log(cartUpdated)
                        elem.children[0].textContent = spanText
                    })
                } else {
                    elem.children[0].textContent = 'NO HAY STOCK'
                    setTimeout( () => { elem.children[0].textContent = spanText }, 1500)
                }
            }
        })
    })

    function getCart( callback ) {
        if ( typeof callback === 'function' ) {
            ( async () => {
                const cart = await ( await fetch('/cart.js') ).json();
                callback( cart )
            })()
        } else {
            return (() => { throw new Error('Expecting function') })()
        }
    }

    function addToCart( varId, qty, callback ) {
        ( async () => {
            try {
                const cartAdd = await ( 
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: varId, quantity: qty })
                    })
                ).json();
                
                getCart( cart => { 
                    callback( cart )
                    $('body').trigger('added.ajaxProduct')
                })

            } catch ( err ) {
                return (() => { throw new Error('Expecting function') })()
            }
        })()
    }
})()